import DashboardLink from './DashboardLink';
import InlineTableTitle from './InlineTableTitle';
import type { DashboardUrl, TableTitleModel } from '../types';

/**
 * Title row shared by every inline list widget: the title and the right-aligned
 * "View all" link.
 *
 * `min-h-10` pins the row to the link's height (DS Button sm = h-8, plus py-1)
 * so linkless rows sit at the same height.
 */
const InlineTableHeader = ({
    title,
    link,
}: {
    title: TableTitleModel;
    link?: DashboardUrl;
}) => (
    <div className="flex min-h-10 items-center justify-between gap-2 border-b border-med-em px-4 py-1">
        <div className="flex min-w-0 items-center">
            <InlineTableTitle {...title} />
        </div>
        <DashboardLink link={link} label="View all" />
    </div>
);

export default InlineTableHeader;
